import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

import { styledReset } from '@pkg/primitives';

export const TriggerButton = styled.button<{ $isOpen?: boolean }>`
    ${styledReset.button}

    white-space: nowrap;
    border-radius: 6px;
    user-select: none;

    width: 30px;
    height: 30px;
    flex-shrink: 0;

    display: flex;
    align-items: center;
    justify-content: center;

    cursor: pointer;
    user-select: none;
    pointer-events: all;

    svg {
        fill: none;
    }

    transition:
        background-color 0.2s ease-in-out,
        box-shadow 0.2s ease-in-out;
    background-color: rgba(9, 7, 25, 0.7);

    &:hover {
        background-color: rgba(9, 7, 25, 1);
        box-shadow: 0 0 1px 0 rgba(255, 255, 255, 0.5) inset;
    }

    ${({ $isOpen }) =>
        $isOpen &&
        css`
            background-color: rgba(9, 7, 25, 1);
            box-shadow: 0 0 1px 0 rgba(255, 255, 255, 0.5) inset;
        `}
`;

export const MenuWrapper = styled.div`
    width: 100%;
    max-width: 180px;

    @media (max-width: 768px) {
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        z-index: 98;
        max-width: 100%;
        width: 100%;
        height: 100dvh;
    }
`;

export const MenuInside = styled(motion.div)`
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    padding: 5px;

    width: 100%;

    background: rgba(9, 7, 25, 0.7);
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(30px);

    @media (max-width: 768px) {
        padding: 20px 10px 90px 10px;
        background: #000;
        position: absolute;
        bottom: 0;
        left: 0;
        z-index: 2;
    }
`;

export const MenuButton = styled.button`
    ${styledReset.button}
    color: #fff;

    font-size: 12px;
    font-weight: 700;
    line-height: 100%;
    letter-spacing: -0.12px;
    text-align: left;
    justify-content: flex-start;

    padding: 10px 16px;
    border-radius: 5px;

    transition: background-color 0.2s ease-in-out;

    &:disabled {
        opacity: 0.7;
        pointer-events: none;
    }

    &:hover {
        background-color: rgba(255, 255, 255, 0.1);
    }

    @media (max-width: 768px) {
        width: 100%;
        font-size: 16px;
        text-align: center;
        padding: 14px 16px;
    }
`;

export const MenuBackdrop = styled.div`
    @media (max-width: 768px) {
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        z-index: 1;
        max-width: 100%;
        width: 100%;
        height: 100dvh;
        background-color: rgba(9, 7, 25, 0.6);
        backdrop-filter: blur(3px);
    }
`;
